import { Form, Col, Row, Input } from "antd";
import { FormInstance } from "antd/lib/form/Form";
import Title from "antd/lib/typography/Title";
import React from "react";
import { DataGrid } from "@core-ui/datagrid";
import { IOrganisationIndexGroup } from "../../model/OrganisationIndexGroup";

interface OrganisationIndexGroupSwithFormProps {
  translate: any;
  referenceLoader?: boolean;
  groups: IOrganisationIndexGroup[];
  toggleSwitchGroup: any;
  form: FormInstance;
  searchGroupFunction: any;
}
const OrganisationIndexGroupSwithForm: React.FC<OrganisationIndexGroupSwithFormProps> =
  ({ translate, groups, toggleSwitchGroup, form, searchGroupFunction }) => {
    const changeGroup = (index, e) => {
      toggleSwitchGroup(index);
    };

    const columns = [
      {
        title: translate("editors.organisation_index_groups.name"),
        key: "name",
        dataIndex: ["name"]
      },
      {
        title: translate("editors.organisation_index_groups.select_group"),
        render: (record) => (
          <Input
            type={"radio"}
            name={"group"}
            style={{
              width: "1em",
              marginLeft: "5em",
              height: "1em",
              cursor: "pointer"
            }}
            onChange={(e) => {
              changeGroup(record, e);
            }}
            defaultChecked={false}
          />
        )
      }
    ];

    return (
      <Form form={form}>
        <Row className={"datagrid-header"}>
          <Col lg={18} sm={13}>
            <Title level={1} className={"datagrid-title"}>
              {translate("editors.organisation_index_groups.switch_title")}
            </Title>
          </Col>
        </Row>
        <Row>
          <div style={{ marginTop: "1em", marginBottom: "2.5em" }}>
            {translate("editors.organisation_index_groups.switch_message")}
          </div>
        </Row>
        <Row>
          <Col span={24}>
            <DataGrid
              tableFormManager={{
                columns: columns,
                dataSource: groups,
                keyProperty: "id",
                locale: {},
                childrenColumnName: "",
                singleRowExpandEnabled: false,
                customExpandIcon: () => null
              }}
              headerFormManager={{ title: "" }}
              searchFormManager={{
                searchEnabled: true,
                searchTablePlaceholder: translate(
                  "editors.organisation_index_groups.search_label"
                ),
                searchFunction: searchGroupFunction
              }}
              pagingFormManager={{
                dataSource: groups,
                itemsPerPageLabel: "",
                showingLabel: translate(
                  "editors.organisation_index_groups.showing_label"
                ),
                totalLabel: translate(
                  "editors.organisation_index_groups.total_label"
                ),
                toLabel: translate(
                  "editors.organisation_index_groups.to_label"
                ),
                pageSize: 10
              }}
              deleteModalFormManager={{}}
              createModalFormManager={{}}
              updateModalFormManager={{}}
            />
          </Col>
        </Row>
      </Form>
    );
  };
export default OrganisationIndexGroupSwithForm;
